import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppUserService } from '@ceres/shared/services';
import { filter, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SchedulingGuard implements CanActivate {
    private appUserService = inject(AppUserService);
    private router = inject(Router);

    canActivate(): Observable<boolean | UrlTree> {
        return this.appUserService.loggedInUser$.pipe(
            filter((user) => !!user),
            map(() => (this.appUserService.hasSchedulingAccess() ? true : this.router.createUrlTree(['/'])))
        );
    }
}
